import { useState } from 'react';
import ShopifyLogo from '../../icons/ShopifyLogo';

function Products({ onComplete }) {
  const [isShopifyConnected, setIsShopifyConnected] = useState(false);

  const handleConnectShopify = () => {
    // TODO: Implement Shopify connection
    setIsShopifyConnected(true);
    onComplete(true);
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="flex items-center space-x-2 mb-6">
        <span className="text-green-500">🛍️</span>
        <h2 className="text-lg font-medium">Products</h2>
      </div>
      <p className="text-sm text-gray-600 mb-6">
        Identify the main product categories of your online store and identify your best-selling items. This overview helps us understand the core of your business and the products that resonate most with your consumers.
      </p>

      <div className="bg-gray-50 rounded-lg p-6">
        <div className="flex items-center mb-4">
          <span className="text-green-600">🛍️</span>
          <p className="text-sm text-gray-600 ml-2">This feature works better with Shopify connected!</p>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <ShopifyLogo className="h-6 w-6" />
            <span className="ml-2 text-sm font-medium text-gray-900">Connect your Shopify store</span>
          </div>
          <button
            onClick={handleConnectShopify}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
          >
            Connect Shopify
          </button>
        </div>
      </div>

      {isShopifyConnected && (
        <div className="mt-6">
          <p className="text-sm text-gray-500 mb-4">Your products will appear here once Shopify is connected.</p>
        </div>
      )}
    </div>
  );
}

export default Products;